import React from 'react';
import {
  Create,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';
import TargetGroupInput from '../../../../commonComponents/TargetGroupInput';
import ImageInput from '../../../../commonComponents/UploadInputs/ImageInput';
import { bonusShopCategoryTypes, uploadTypes } from '../../../../config/constants';
import VoucherLimitInputs, { transformVoucherLimit } from './VoucherLimitInputs';

const CategoryCreate = (props) => (
  <Create title="Add Category" transform={transformVoucherLimit} {...props}>
    <SimpleForm redirect="list">
      <TextInput label="Name" source="name" validate={required()} />
      <ImageInput imageInputSource="photo" validate={required()} uploadType={uploadTypes.allUploads} />
      <NumberInput label="Priority" source="priority" />
      <ReferenceInput
        label="Transaction Type"
        source="transaction_type_id"
        reference="admin/transactions/types"
        perPage={100}
      >
        <SelectInput validate={required()} />
      </ReferenceInput>
      <TargetGroupInput />
      <ReferenceInput label="Type" source="type" reference="admin/bonus-shop/category-types">
        <SelectInput validate={required()} />
      </ReferenceInput>
      <VoucherLimitInputs />
      <FormDataConsumer>
        {({ formData }) => {
          const { type } = formData;
          return type === bonusShopCategoryTypes.TRANSFER ? (
            <ImageInput
              label="Header Image"
              imageInputSource="header_image"
              uploadType={uploadTypes.allUploads}
              validate={required()}
            />
          ) : null;
        }}
      </FormDataConsumer>
    </SimpleForm>
  </Create>
);

export default CategoryCreate;
